<template>
  <b-button-group :size="size">
    <b-button class="d-none d-lg-inline" variant="primary" :disabled="pagination.current_page === 1" @click.prevent="change(1)">First</b-button>
    <b-button variant="primary" :disabled="pagination.current_page === 1" @click.prevent="change(pagination.current_page - 1)">
        <i class="fa fa-chevron-left d-none d-lg-inline" aria-hidden="true"></i>
        <span class="d-inline d-lg-none">Prev</span>
    </b-button>
    
    <!-- Loop halaman dari links -->
    <b-button
      v-for="(link, index) in pageLinks"
      class="d-none d-lg-inline"
      :key="index"
      :variant="link.active ? 'dark' : 'outline-primary'"
      :disabled="!link.url"
      v-html="link.label"
      @click.prevent="goToPage(link)"
    />
    
    <b-button variant="primary" :disabled="isLastPage" @click.prevent="change(pagination.current_page + 1)">
        <i class="fa fa-chevron-right d-none d-lg-inline" aria-hidden="true"></i>
        <span class="d-inline d-lg-none">Next</span>
    </b-button>
    <b-button class="d-none d-lg-inline" variant="primary" :disabled="isLastPage" @click.prevent="change(pagination.last_page)">Last</b-button>
  </b-button-group>
</template>

<script>
export default {
  name: "LaravelPagination",
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: "md",
    },
  },
  computed: {
    isLastPage() {
      return this.pagination.current_page === this.pagination.last_page;
    },
    pageLinks() {
      // buang elemen pertama (prev) dan terakhir (next)
      if (!this.pagination.links) return [];
      return this.pagination.links.slice(1, -1);
    },
  },
  data() {
    return {
      visiblePages: [1,2,3,4,5], // Contoh halaman yang terlihat
    };
  },
  methods:{
    change(page) {
      this.$emit("change", page); // trigger ke parent
    },
    goToPage(link) {
      if (!link.url) return;
      const params = new URL(link.url, window.location.origin).searchParams;
      const page = parseInt(params.get("page")) || 1;
      this.change(page);
    }
  },
}
</script>